/**
 * @file Loop-lifecycle Valtio bus shared between `AIProvider` (writer) and
 * `useAgentContext` (reader).
 *
 * - `runningSnapshot` — `AIProvider` writes the bound `page.ids` at the
 *   start of each agentic loop and clears it on `finish` / `error` /
 *   `clearMessages` / abort. Null while no loop is running.
 *
 * The "user navigated away" signal is derived at read time from
 * `runningSnapshot` + the current route ids (see `useAgentContext`); it is
 * not stored here. Consumers compute it on demand at submit / cancel time
 * and ship the `userNavigatedAway` flag on the next outgoing request.
 */
import { proxy } from 'valtio';
import type { PageIds } from '#types';

export const agentLoopState = proxy<{
    runningSnapshot: PageIds | null;
}>({
    runningSnapshot: null,
});
